import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * AIDEV-NOTE: NoLayout - Routes Without Layout Chrome
 * ====================================================
 * This component wraps routes that don't need header/footer.
 * Uses React Router's <Outlet> to render child routes.
 *
 * USED FOR:
 * - Signup flow
 * - Callback pages
 * - Full-screen experiences
 */
export const NoLayout: React.FC = () => {
  return <Outlet />;
};
